import React from 'react';

import ModalBase from './ModalBase';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';

import TDialogModal from './@types/TDialogModal';
import TModalBase from './@types/TModalBase';
import TModalFooter from './@types/TModalFooter';

const DialogModal = ({
  title,
  children,
  buttons,
  onClose,
  buttonsAlignmentDesktop,
  buttonsAlignmentMobile = 'stretched',
  contentClassName,
  ...rest
}: TModalBase & TDialogModal & TModalFooter) => (
  <ModalBase kind="dialog" onClose={onClose} {...rest}>
    {title && <ModalHeader title={title} />}
    <ModalContent className={contentClassName}>{children}</ModalContent>
    <ModalFooter
      buttons={buttons}
      buttonsAlignmentDesktop={buttonsAlignmentDesktop}
      buttonsAlignmentMobile={buttonsAlignmentMobile}
    />
  </ModalBase>
);

export default DialogModal;
